import { Controller } from '@hotwired/stimulus'
import { UAParser } from 'ua-parser-js'

export default class extends Controller {
  static targets = ['form', 'requiredInput']
  static values = {
    errorMessage: { type: String, default: 'You must enter a message' }
  }

  connect() {
    this.setPlaceholderText()
  }

  setPlaceholderText() {
    const { device } = UAParser(navigator.userAgent)
    const shortcutText = device.vendor === 'Apple' ? 'Cmd+↵' : 'Ctrl+↵'

    this.requiredInputTargets.forEach(input => {
      if (input.hasAttribute('placeholder')) {
        input.setAttribute('placeholder', `Type here... (${shortcutText} to send)`)
      }
    })
  }

  validate() {
    let isInvalid = false
    this.requiredInputTargets.forEach(input => {
      if (!input.disabled && !input.value.trim()) {
        isInvalid = true
      }
    })
    this.isInvalid = isInvalid
  }

  submit(event) {
    this.validate()
    if (this.isInvalid) {
      event.preventDefault()
      document.dispatchEvent(new CustomEvent('toast', { detail: { message: this.errorMessageValue } }))
    }
  }

  handleKeydown(event) {
    // Submit on Cmd+Enter/Ctrl+Enter (allow Enter/Shift+Enter for new lines)
    const submitShortcut = event.key === 'Enter' && (event.metaKey || event.ctrlKey)

    if (submitShortcut) {
      event.preventDefault()

      // If its empty, don't submit
      this.validate()
      if (this.isInvalid) {
        return
      }

      // Check if form is already loading
      const isLoading = this.formTarget.hasAttribute('aria-busy')

      if (!isLoading) {
        this.formTarget.requestSubmit()
      }
    }
  }

  clearForm() {
    this.requiredInputTargets.forEach(input => {
      input.value = ''
      input.textContent = ''
    })
  }
}
